import type { CSSProperties, ReactNode } from 'react';
import { ArrowLeft, LayoutDashboard, Search } from 'lucide-react';

function shortcutHint() {
  if (typeof navigator === 'undefined') return 'Ctrl K';
  return /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent) ? 'Cmd K' : 'Ctrl K';
}

export function PremiumSlimBar({
  showBack = false,
  onBack,
  onDashboard,
  dashboardLabel = 'Dashboard',
  dashboardCurrent = false,
  modeSwitch,
  onSearch,
  backGlyph,
  className = '',
  style,
  children,
}: {
  showBack?: boolean;
  onBack?: () => void;
  onDashboard?: () => void;
  dashboardLabel?: string;
  dashboardCurrent?: boolean;
  modeSwitch?: ReactNode;
  /** Wide screens only: opens the app directory. Hidden below 1100px. */
  onSearch?: () => void;
  /** Replaces the default arrow on the Back control (the iPhone dock uses a chevron). */
  backGlyph?: ReactNode;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}) {
  return (
    <header className={`premium-slim-bar premium-app-topbar ${className}`.trim()} style={style}>
      <nav className="standard-recovery-bar premium-slim-bar__lead" aria-label="Page navigation">
        {showBack && onBack ? (
          <button type="button" className="premium-slim-bar__back" onClick={onBack}>
            {backGlyph ?? <ArrowLeft aria-hidden="true" />}
            <span>Back</span>
          </button>
        ) : null}
        {modeSwitch}
        {onDashboard ? (
          <button
            type="button"
            className="premium-slim-bar__dash"
            onClick={onDashboard}
            aria-current={dashboardCurrent ? 'page' : undefined}
          >
            <LayoutDashboard aria-hidden="true" />
            <span>{dashboardLabel}</span>
          </button>
        ) : null}
        {onSearch ? (
          <button
            type="button"
            className="premium-slim-bar__search"
            onClick={onSearch}
            aria-keyshortcuts="Control+K Meta+K"
          >
            <Search aria-hidden="true" />
            <span>Search or jump to anything</span>
            <kbd aria-hidden="true">{shortcutHint()}</kbd>
          </button>
        ) : null}
      </nav>
      {children ? <div className="premium-slim-bar__tools">{children}</div> : null}
    </header>
  );
}
